import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Crown } from "lucide-react";
import api from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";

export default function NewsPost() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    api
      .get(`/posts/${id}`)
      .then((r) => setPost(r.data))
      .catch(() => setMissing(true));
  }, [id]);

  if (missing) {
    return (
      <div data-testid="news-post-missing" className="flex h-screen flex-col items-center justify-center gap-6 bg-[#050505] text-neutral-400">
        Story not found.
        <Link to="/" data-testid="news-back-link" className="text-[#D4AF37]">Return Home</Link>
      </div>
    );
  }

  if (!post) {
    return (
      <div data-testid="news-post-loading" className="flex h-screen items-center justify-center bg-[#050505]">
        <Crown className="animate-crown-pulse h-10 w-10 text-[#D4AF37]" strokeWidth={1} />
      </div>
    );
  }

  return (
    <div data-testid="news-post-page" className="min-h-screen bg-[#050505] text-white">
      <header className="border-b border-white/10 backdrop-blur-xl">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-6">
          <Link to="/" data-testid="news-back-home" className="flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-neutral-300 transition-colors hover:text-[#D4AF37]">
            <ArrowLeft className="h-4 w-4" strokeWidth={1} /> Back to the House
          </Link>
          <span className="font-script text-2xl text-[#D4AF37]">D'La Valentina</span>
        </div>
      </header>
      <article className="mx-auto max-w-4xl px-6 py-16">
        <Reveal>
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]/80">
            {post.created_at ? new Date(post.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" }) : ""}
          </span>
          <h1 data-testid="news-post-title" className="font-display mt-4 text-4xl font-medium leading-tight md:text-5xl">
            {post.title}
          </h1>
        </Reveal>
        {post.image && (
          <Reveal delay={0.15} className="mt-10">
            <img src={post.image} alt={post.title} data-testid="news-post-image" className="max-h-[70vh] w-full border border-[#D4AF37]/20 bg-black object-contain" />
          </Reveal>
        )}
        <Reveal delay={0.25} className="mt-12">
          <div data-testid="news-post-content" className="space-y-6">
            {(post.content || "").split("\n").filter(Boolean).map((para, i) => (
              <p key={i} className="text-base font-light leading-loose tracking-wide text-neutral-300">
                {para}
              </p>
            ))}
          </div>
        </Reveal>
      </article>
    </div>
  );
}
